import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Global } from "../../utils/Global";

export const Grado = ({ updateValue, nuevoValue, disabled }) => {
  const [grado, setGrado] = useState({
    label: Global().grado[0],
    value: Global().grado[0],
  });

  useEffect(() => {
    if (
      nuevoValue != null &&
      nuevoValue != "" &&
      nuevoValue.value != grado.value
    ) {
      setGrado({ value: nuevoValue, label: nuevoValue });
    }
  }, [nuevoValue]);

  return (
    <Select
      isDisabled={disabled}
      value={grado}
      name="grado"
      onChange={(choice) => {
        updateValue("grado", choice.value);
        setGrado(choice);
      }}
      placeholder="Seleccione"
      options={Global().grado.map((c) => {
        return { value: c, label: c };
      })}
    />
  );
};
